/*
 * Public API Surface of angular-dayjs
 */

export * from './lib/angular-dayjs.service';
export * from './lib/angular-dayjs.module';
